import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/ButtonBase';

const CardHeader = styled(Button)`
     &.stolo-card-header {
          font-family:  ${props => props.theme.condensed};
          font-weight: normal;
          margin: 0px;
          padding: ${props => props.theme.space[2]};
          padding-left: ${props => props.theme.space[3]};
          color: ${props => props.theme.palette.common.text};
          background-color: ${props => props.theme.palette.background.paper};
          text-transform: none;
          width: 100%;
          justify-content: flex-start;
          min-height: inherit;
      }
    `;

const PatternCardHeader = ({ title }) => (
    <CardHeader
        classes={{ root: 'stolo-card-header' }}
        component='div'
    >
        {title}
    </CardHeader>
);


export default PatternCardHeader;



// WEBPACK FOOTER //
// ./src/components/patterngalleries/PatternCardHeader.js